import React, { createContext, useContext, useMemo, useState } from "react";

import { LongTermDisabilityPlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: LongTermDisabilityPlan;
  planCost: PlanCost;
}
interface LongTermDisabilityContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: LongTermDisabilityPlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const LongTermDisabilityContext = createContext<LongTermDisabilityContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: LongTermDisabilityPlan;
  planCost: PlanCost;
}
export const LongTermDisabilityContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<LongTermDisabilityPlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };

    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <LongTermDisabilityContext.Provider value={contextValue}>{children}</LongTermDisabilityContext.Provider>;
};

export const useLongTermDisabilityContext = () => useContext(LongTermDisabilityContext);
